module.exports = __webpack_public_path__ + "img/hk01-20201209.57a11ac8.png";